import Box from '@sendsprint/ui-react/dist/components/Box';
import Button from '@sendsprint/ui-react/dist/components/Button';
import Icon from '@sendsprint/ui-react/dist/components/Icon';
import Text from '@sendsprint/ui-react/dist/components/Text';
import React from 'react';
import AlertCircleOutline from '@sendsprint/ui-react/dist/icons/AlertCircleOutline';
import { useNavigate } from 'react-router-dom';
import { Path } from '@src/navigations/routes';

const NoPrimaryAccount = () => {
  const navigate = useNavigate();

  const handleNavigate = () => navigate(`${Path.ReceiverSettlementAccount}?add=true`);
  return (
    <Box className="ss-flex ss-flex-col ss-items-center ss-py-20">
      <Box>
        <Icon svg={AlertCircleOutline} size={80} className="ss-text-warning-400" />
      </Box>
      <Text variant="h5" className="ss-text-center">
        No primary settlement account found!
      </Text>
      <Text className="ss-mb-10 ss-text-center ss-max-w-[400px]">
        Please add a primary settlement account by either clicking this button, or updating an
        existing settlement account.
      </Text>
      <Button onClick={handleNavigate} label="Add settlement account" />
    </Box>
  );
};

export default NoPrimaryAccount;
